<div class="ota-device-key-page">
	<div class="breadcrumb">
		<a [routerLink]="'/dashboard'">Home</a>
		<span class="separator">›</span>
		<span class="current">Device Keys</span>
	</div>

	<div class="main-content">
		<div class="page-header">
			<div>
				<!-- <h2>OTA Device Keys</h2> -->
				<!-- <p>Create signing keys and review previously generated public keys.</p> -->
                 <h2>OTA Device Keys</h2>
                 <p>Create device model keys for sigining the nonce or OTA package.</p>
			</div>
		</div>

		<div class="form-wrapper">
			<div class="form-container">
				<div class="form-column">
					<div class="form-section">
						<h3>Key Creation</h3>

						<div class="form-group">
							<label>Signing Model</label>
							<input
								type="text"
								class="form-control"
								placeholder="Type here"
								[(ngModel)]="formData.signingModel"
							/>
						</div>

						<div class="form-row three-column-row">
							<div class="form-group">
								<label>Signing Algorithm</label>
								<mat-form-field appearance="outline" class="full-width select-field">
									<mat-select [(ngModel)]="formData.signingAlgorithm" panelClass="mat-mdc-select-panel-custom">
										<mat-option *ngFor="let option of signingAlgorithmOptions" [value]="option.value">
											{{ option.label }}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>

							<div class="form-group">
								<label>Number of Keys</label>
								<mat-form-field appearance="outline" class="full-width select-field">
									<mat-select [(ngModel)]="formData.numberOfKeys" panelClass="mat-mdc-select-panel-custom">
										<mat-option *ngFor="let option of numberOfKeysOptions" [value]="+option.value">
											{{ option.label }}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
						</div>

						<div class="actions-row">
							<button class="create-btn" (click)="createKeys()" [disabled]="!formData.signingModel.trim()">Create Keys</button>
						</div>
					</div>
				</div>

				<div class="preview-column">
					<div class="preview-header">Preview</div>
					<div class="preview-section">
						<div class="preview-item">
							<span class="preview-label">Signing Model</span>
							<span class="preview-value">{{ formData.signingModel || '' }}</span>
						</div>
						<div class="preview-item">
							<span class="preview-label">Signing Algorithm</span>
							<span class="preview-value">{{ formData.signingAlgorithm }}</span>
						</div>
						<div class="preview-item">
							<span class="preview-label">Number of Keys</span>
							<span class="preview-value">{{ formData.numberOfKeys }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="list-section">
			<div class="section-header">
				<h3>Generated Keys</h3>
			</div>

			<div class="records-section">
				<div class="records-count">
					<strong>{{ totalRecords }}</strong> Records
				</div>

				<div class="search-section">
					<mat-form-field class="filter-dropdown-container" appearance="outline">
						<mat-label>Search by</mat-label>
						<mat-select [(ngModel)]="selectedFilterValue" (selectionChange)="onFilterSelectionChange($event.value)"
							panelClass="mat-mdc-select-panel-custom">
							<mat-option *ngFor="let option of filterOptions" [value]="option.value">
								{{ option.label }}
							</mat-option>
						</mat-select>
					</mat-form-field>
					<div class="search-bar">
						<input matInput [(ngModel)]="searchQuery" placeholder="Type here" appEnterKey (enterKey)="onSearch()">
						<button class="search-btn" (click)="onSearch()">
							<img src="assets/search-icon.svg" alt="Search">
						</button>
					</div>
				</div>
			</div>

			<div class="table-container">
				<table class="jobs-table">
					<thead>
						<!-- <tr>
							<th>Created By</th>
							<th>Created At</th>
							<th>Model</th>
							<th>Encryption Algorithm</th>
							<th>Key Algorithm</th>
							<th>Key Length</th>
							<th>Public Keys</th>
						</tr> -->
						<tr>
							<th>Model</th>
							<th>Key Algorithm</th>
							<th>Key Length</th>
							<th>Created By</th>
							<th>Created At</th>
							<th>Public Keys</th>
						</tr>
					</thead>
                    <tbody>
                        <ng-container *ngIf="paginatedGeneratedKeys.length > 0; else noRecords">
                            <tr *ngFor="let record of paginatedGeneratedKeys; trackBy: trackByCreatedAt; let ri = index">
								<td>{{ record.model }}</td>
                                <td>{{ record.keyAlgorithm }}</td>
                                <td>{{ record.keyLength }}</td>
                                <td>{{ record.createdBy }}</td>
                                <td>{{ record.createdAt | date:'yyyy-MM-dd HH:mm:ss' }}</td>
                                <td>
                                    <div class="public-keys-cell">
										<button class="view-btn" (click)="openKeyPopup(record.publicKeys)">View Keys</button>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                    
                        <ng-template #noRecords>
                            <tr>
                                <td colspan="7" class="no-records">
                                    No records found
                                </td>
                            </tr>
                        </ng-template>
                    </tbody>
				</table>
			</div>

			<div class="pagination-section" *ngIf="totalRecords > 0">
				<span class="pagination-info">
					{{ startItem }}-{{ endItem }} of {{ totalPages }} pages
				</span>
				<div class="pagination">
					<button class="pagination-btn" (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1">
						←
					</button>
					<button
						*ngFor="let page of getPageNumbers()"
						class="pagination-btn"
						[class.active]="page === currentPage"
						(click)="goToPage(page)">
						{{ page }}
					</button>
					<button class="pagination-btn" (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages">
						→
					</button>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- Public Key Popup -->
<div class="key-popup-overlay" *ngIf="popupKeys?.length" (click)="closeKeyPopup()">
	<div class="key-popup" (click)="$event.stopPropagation()">
		<div class="key-popup-header">
			<span class="key-popup-title">Public Keys</span>
			<button class="key-popup-close" (click)="closeKeyPopup()">&#x2715;</button>
		</div>
		<div class="key-popup-body">
			<div class="key-entry" *ngFor="let entry of popupKeys">
				<div class="key-name">{{ entry.id }}</div>
				<pre class="key-popup-content">{{ entry.value }}</pre>
				<div class="key-popup-actions">
					<button class="copy-btn popup-copy-btn" [class.copied]="copiedKeyId === entry.id" (click)="copyToClipboard(entry.id, entry.value)">
					{{ copiedKeyId === entry.id ? 'Copied!' : 'Copy' }}
					</button>
				</div>
			</div>
		</div>
	</div>
</div>
